import { CometChat } from "@cometchat/chat-sdk-javascript";
import { treatment_program } from "./constants/common";

const authKey = process.env.REACT_APP_COMETCHAT_AUTH_KEY;

export const presenceMap = {};
let presenceListenerRegistered = false;

function registerPresenceListener() {
  if (presenceListenerRegistered) return;
  CometChat.addUserListener(
    "PRESENCE_LISTENER_ID",
    new CometChat.UserListener({
      onUserOnline: (onlineUser) => {
        presenceMap[onlineUser.getUid()] = "online";
      },
      onUserOffline: (offlineUser) => {
        presenceMap[offlineUser.getUid()] = "offline";
      }
    })
  );
  presenceListenerRegistered = true;
  console.log("Presence listener registered");
}

const generateUID = (info) => {
  return `${info?.id}`;
};

export const initializeCometChat = async (info) => {
  if (!info?.id) return false;
  const uid = generateUID(info);

  try {
    const user = await CometChat.login(uid, authKey);
    registerPresenceListener();
    return user;
  } catch (loginError) {
    if (loginError.code === 'ERR_UID_NOT_FOUND') {
      try {
        const newUser = new CometChat.User(uid);
        newUser.setName(`${info?.first_name || ''} ${info?.last_name || ''}`.trim());
        const avatar = info?.user_info?.user_profile_image || info?.main_image;
        if (avatar) newUser.setAvatar(avatar);

        const createdUser = await CometChat.createUser(newUser, authKey);
        const loginUser = await CometChat.login(uid, authKey);
        registerPresenceListener();
        return loginUser;
      } catch (createError) {
        console.error("User creation failed:", createError);
        return false;
      }
    } else {
      console.error("Login failed:", loginError);
      return false;
    }
  }
};


export const loggedInUserCometChat = async (info) => {
  if (!info?.id) return false;

  try {
    const loggedInUser = await CometChat.getLoggedinUser();
    if (loggedInUser) {
      if (!window._presenceListenerRegistered) {
        registerPresenceListener();
        window._presenceListenerRegistered = true;
      }
      return loggedInUser;
    }
    return await initializeCometChat(info);
  } catch (error) {
    console.error("Error checking logged in user:", error);
    return false;
  }
};